var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgConnectionNonetwork = function SvgConnectionNonetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#BABABA",
    x: 3,
    y: 11,
    width: 4,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BABABA",
    x: 9,
    y: 7,
    width: 4,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BABABA",
    x: 15,
    y: 3,
    width: 4,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m6.346 2 1.058 1.053-1.645 1.633 1.645 1.633-1.058 1.053L4.702 5.74 3.058 7.372 2 6.32l1.644-1.633L2 3.053 3.058 2l1.644 1.633z"
  }))));
};

export default SvgConnectionNonetwork;